import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';

export default function HeroSection() {
  const { t, i18n } = useTranslation();
  const { lang } = useParams();
  const isJa = i18n.language === 'ja';

  return (
    <section className="relative min-h-[88vh] md:min-h-[85vh] flex items-start justify-center overflow-hidden">
      {/* 背景画像（PC/SP出し分け） */}
      <picture className="absolute inset-0">
        <source
          media="(min-width: 768px)"
          srcSet="/hero-desktop.png"
        />
        <img
          src="/hero-mobile.png"
          alt=""
          className="w-full h-full object-cover"
        />
      </picture>

      {/* オーバーレイ（可読性のため） */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/35 to-black/0" />
      {/* 局所暗幕（文字の常時可読性のため - 必須） */}
      <div
        className="absolute inset-0"
        style={{
          background: 'radial-gradient(circle at 50% 20%, rgba(0,0,0,0.55), transparent 55%)'
        }}
      />

      {/* コンテンツ（やや上寄せ） */}
      <div className="relative z-10 text-center px-4 pt-16 md:pt-20">
        {/* H1 タイトル */}
        <h1
          className="text-4xl md:text-5xl lg:text-6xl font-serif tracking-[0.12em] md:tracking-[0.16em] text-white drop-shadow-[0_6px_24px_rgba(0,0,0,0.85)]"
        >
          {t('hero.title')}
        </h1>

        {/* 日本語補助（jaトップのみ） */}
        {isJa && (
          <p className="mt-3 text-sm md:text-lg text-white/70 tracking-[0.18em]">
            {t('hero.titleJa')}
          </p>
        )}

        {/* 定義の1行（v0.8.0 追加） */}
        <p className="mt-6 text-base md:text-lg text-white/85 leading-relaxed max-w-2xl mx-auto">
          {t('hero.definition')}
        </p>

        {/* キャッチコピー */}
        <p className="mt-6 text-lg md:text-2xl text-white/90 tracking-[0.22em] drop-shadow-[0_6px_24px_rgba(0,0,0,0.85)]">
          {t('hero.catchCopy')}
        </p>

        {/* サブコピー（v0.8.0 で1行に） */}
        <p className="mt-4 text-base md:text-lg text-white/80 leading-relaxed">
          {t('hero.subCopy')}
        </p>

        {/* CTAボタン（v0.8.0 で変更） */}
        <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to={`/${lang}/story`}
            className="inline-flex items-center justify-center rounded-full px-8 py-3 transition backdrop-blur-sm border border-white/60 text-white/90 hover:bg-white/15 hover:border-white/80"
          >
            {t('hero.ctaPrimary')}
          </Link>
          <a
            href="#prologue"
            className="inline-flex items-center justify-center rounded-full px-6 py-3 transition backdrop-blur-sm border border-white/30 text-white/80 hover:bg-white/5"
          >
            {t('hero.ctaSecondary')}
          </a>
        </div>
      </div>

      {/* スクロールインジケーター */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <svg className="w-6 h-6 text-white/60" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
        </svg>
      </div>
    </section>
  );
}
